import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=6854b5c9&scoped=true"
import script from "./analysis.vue?vue&type=script&lang=js"
export * from "./analysis.vue?vue&type=script&lang=js"
import style0 from "./analysis.vue?vue&type=style&index=0&id=6854b5c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6854b5c9",
  null
  
)

export default component.exports